import React from 'react';
import { Mail } from 'lucide-react';

export const Support: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <Mail className="w-16 h-16 text-blue-600 dark:text-blue-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Need Help?
          </h1>
          <p className="text-gray-600 dark:text-gray-300">
            Email us at support@caloriecat.app
          </p>
        </div>
        
        <a 
          href="mailto:support@caloriecat.app"
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors"
        >
          <Mail className="w-4 h-4" />
          Send Email
        </a>
      </div>
    </div>
  );
};